import React, { useState } from "react";
import Input from "../components/shared/input";
import Button from "../components/shared/button";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { toast } from "react-toastify";

const Forgetpswd = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const [formData, setFormData] = useState({ email: "" });
  const [isLoading, setIsLoading] = useState(false);
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const validateForm = () => {
    const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    const newErrors = {};
    if (!formData.email) {
      newErrors.email = "Email is required.";
    } else if (!emailRegex.test(formData.email)) {
      newErrors.email = "Email is invalid.";
    } else if (/\s/.test(formData.email)) {
      newErrors.email = "Email cannot contain spaces.";
    }
    return newErrors;
  };

  const handleContinue = async (e) => {
    e.preventDefault();
    const url = `${process.env.REACT_APP_NODE_BASE_URL}/user/verify-email`;

    const payload = { email: formData.email };

    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      setIsLoading(false);
      return;
    }
    setErrors("");

    try {
      setIsLoading(true);
      const response = await axios.post(url, payload, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 200 || response.status === 201) {
        toast.success("Email verified successfully!");
        navigate("/verify-code", {
          state: { userEmail: formData.email },
        });
      } else {
        toast.warn("Invalid email. Please try again.");
      }
    } catch (err) {
      console.log(err);
      toast.warn(err?.response?.data?.message || "An error occurred.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex flex-col lg:flex-row min-h-screen items-center max-md:gap-[60px] max-md:justify-start justify-center bg-lightwhite p-[20px]">
      {/* Left side*/}
      <div className="max-md:min-h-[10vh] max-md:border-none min-h-[80vh] border-solid border-r-2 border-r-gray-200 flex flex-col items-center justify-center w-full md:w-1/2 ">
        <img
          src="../../assets/images/dashboard/logo_large.png"
          alt="logo"
          className="w-100 h-100 max-md:w-[60px] max-md:h-[60px]"
        />
        <p className="text-blue font-bold text-[34px] max-md:text-[18px]">
          {t("forgetpswd.leftSide.title")}
        </p>
      </div>

      {/* Right side*/}
      <div className="flex flex-col items-center justify-center w-full md:w-1/2 ">
        <div className="w-full max-w-sm">
          <h4 className="small font-bold text-black">
            {t("forgetpswd.rightSide.title")}
          </h4>

          <form className="mt-[35px]">
            <Input
            type="email"
            name="email"
            value={formData.email}
            errorMessage={errors?.email}
            onChange={handleInputChange}
            placeholder={t("forgetpswd.rightSide.emailPlaceholder")}
            leftImg="../../assets/icons/Message.svg"
            />
            <Button
              text={t("forgetpswd.rightSide.button")}
              className="button btn-blue w-full mt-[38px]"
              height={50}
              onClick={handleContinue}
              loading={isLoading}
            ></Button>
            <Button
              text={t("forgetpswd.rightSide.goBack")}
              className="button btn-blue-border  w-full mt-[18px] rounded-[8px]"
              height={50}
              onClick={() => {
                navigate("/login");
              }}
            ></Button>
          </form>
          {/* <p className="small flex justify-center gap-[4px] m-auto mt-[8px]">
            {t("forgetpswd.rightSide.noAccount")}
            <a href="/signup" className="font-semibold">
              {t("forgetpswd.rightSide.signup")}
            </a>
          </p> */}
        </div>
      </div>
    </div>
  );
};

export default Forgetpswd;
